import {run} from 'baguettebox.js';

run('.js-gallery', {
    overlayBackgroundColor: 'rgba(255, 255, 255, 0.9)'
});
